import { MAX_IMAGE_SIZE, MIN_IMAGE_SIZE } from './limitImage.constants';
export var resizeImage = function (image, maxTextureSize) {
    if (maxTextureSize === void 0) { maxTextureSize = MAX_IMAGE_SIZE; }
    var _a = limitImageSize({
        width: image.width,
        height: image.height,
    }, maxTextureSize), width = _a.width, height = _a.height;
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var canvasCtx = canvas.getContext('2d');
    if (!canvasCtx) {
        throw new Error('unexpected error');
    }
    canvasCtx.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas;
};
export var fitSize = function (size, bounds) {
    var scale = Math.max(size.width / bounds.width, size.height / bounds.height);
    return {
        width: size.width / scale,
        height: size.height / scale,
    };
};
export var fillSize = function (size, bounds) {
    var scale = Math.min(size.width / bounds.width, size.height / bounds.height);
    return {
        width: size.width / scale,
        height: size.height / scale,
    };
};
export var limitImageSize = function (size, maxTextureSize) {
    if (maxTextureSize === void 0) { maxTextureSize = MAX_IMAGE_SIZE; }
    var width = size.width, height = size.height;
    var maxSize = fitSize(size, {
        width: Math.min(MAX_IMAGE_SIZE, maxTextureSize),
        height: Math.min(MAX_IMAGE_SIZE, maxTextureSize),
    });
    var minSize = fillSize(size, {
        width: MIN_IMAGE_SIZE,
        height: MIN_IMAGE_SIZE,
    });
    if (width < minSize.width || height < minSize.height) {
        return minSize;
    }
    if (width > maxSize.width || height > maxSize.height) {
        return maxSize;
    }
    return { width: width, height: height };
};
//# sourceMappingURL=resizeImage.js.map